import styled from "styled-components";
import { colors } from "@/theme";

export const CartItemsToShipTableTitle = styled.h1`
  color: ${colors.black};
  text-align: center;
  font-family: "PF DIN Text Pro";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0 0 24px 0;
`;
